'use client';

import { c as _c } from "react/compiler-runtime";
import 'swiper/css';
import 'swiper/css/autoplay';
import { FC, useEffect, useRef, useState } from 'react';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from '@/components/Image';
import MotionTrail from '@/components/shared/MotionTrail';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import PersonItem from '@/components/WebsiteProdPage/TeamSection/PersonItem';
import { TeamSectionDto } from '@/components/WebsiteProdPage/TeamSection/types';
import useDevice from '@/hooks/useDevice';
import css from './style.module.scss';
interface Props {
  data: TeamSectionDto;
}
const TeamSection: FC<Props> = t0 => {
  const $ = _c(19);
  const {
    data
  } = t0;
  const device = useDevice();
  const sliderRef = useRef(null);
  const [swiper, setSwiper] = useState(null);
  let t1;
  let t2;
  if ($[0] !== swiper) {
    t1 = () => {
      if (!sliderRef.current || !swiper) {
        return;
      }
      const observer = new IntersectionObserver(t3 => {
        const [entry] = t3;
        if (entry.isIntersecting) {
          swiper.autoplay.start();
        } else {
          swiper.autoplay.stop();
        }
      }, {
        threshold: 0.1
      });
      observer.observe(sliderRef.current);
      return () => observer.disconnect();
    };
    t2 = [swiper];
    $[0] = swiper;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== data.title) {
    t3 = <Typography uppercase={true} className={css.title} variant="h2" tag="h2"><StrapiRichContent content={data.title} /></Typography>;
    $[3] = data.title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== data.mobileAutoplayDelayMilliseconds || $[6] !== data.persons || $[7] !== device) {
    t4 = device === "desktop" ? <MotionTrail className={css.motionTrail} items={data.persons.map(_temp)} /> : <div ref={sliderRef} className={css.mobileSlider}><Swiper loop={true} allowTouchMove={false} modules={[Autoplay]} spaceBetween={0} slidesPerView={1} speed={1} autoplay={{
        delay: data.mobileAutoplayDelayMilliseconds || 200,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }} onSwiper={setSwiper}>{data.persons.map(_temp2)}</Swiper></div>;
    $[5] = data.mobileAutoplayDelayMilliseconds;
    $[6] = data.persons;
    $[7] = device;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image className={css.patternBg} src="/assets/images/website-prod-page/team-section/pattern.webp" width={600} height={600} preload={false} alt="" />;
    t6 = {
      display: "none"
    };
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[11] !== data.persons) {
    t7 = data.persons.map(_temp3);
    $[11] = data.persons;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <div style={t6}>{t7}</div>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t8) {
    t9 = <section className={css.section}>{t3}{t4}{t5}{t8}</section>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
export default TeamSection;
function _temp(person) {
  return <PersonItem key={person.position} person={person} />;
}
function _temp2(person_0) {
  return <SwiperSlide key={person_0.position}><PersonItem person={person_0} className={css.mobilePerson} /></SwiperSlide>;
}
function _temp3(person_1) {
  return <Image key={person_1.position} preload={true} src={person_1.photo.url} width={person_1.photo.width} height={person_1.photo.height} alt={person_1.photo.alternativeText || person_1.position || ""} />;
}